<script src="../../../config/deepCopy.js"></script>
<template>
  <div class="msg_box">
    <h1>{{msg}}</h1>
  </div>
</template>

<script>
import Vue from "vue";
import API from "../../../config/api";
import DOMAIN_PREFIX from "../../../config/domainPrefix";
export default {
name: "afterScan",
  data() {
    return {
      msg: ''
    }
  },
  async mounted() {
    var state = this.$route.query.state
    var scanId = this.$route.query.scanId
    if(state == 0) {
      console.log("state 0");
      this.msg = "正在跳转……"
      if(!Vue.prototype.$appid) {
        let res = await this.$axiosRequest({
            url: API.getWxConfig,
            method: "GET",
            data:{},
        });
        console.log(res);
        res = res[1].data;

        if(res.appid) {
          Vue.prototype.$appid = res.appid
        }
      }
      const url = DOMAIN_PREFIX.WX_LOGIN_PREFIX + 'pages/login/AfterScan?scanId=' + scanId;
      console.log(url);
      location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${Vue.prototype.$appid}&redirect_uri=${encodeURIComponent(url)}&response_type=code&scope=snsapi_userinfo&state=1&connect_redirect=1#wechat_redirect`
    } else {

      let code = this.$route.query.code;
      this.msg += window.location.href;
      this.msg += " " + code;
      let res = await this.$axiosRequest({
        url: API.setScanLoginCode,
        method: "GET",
        data:{
          scanId: scanId,
          code: code
        }
      });
      this.msg += JSON.stringify(res);
      res = res[1].data;
      if(res === 1) {
        this.msg = '扫码登陆成功'
      } else if(res === 0) {
        this.msg = '获取用户信息失败'
      }
    }
  }
}
</script>

<style scoped>
  .msg_box {
    text-align: center;
    width: 100%;
    margin-top: 200px;
  }
</style>